// extracted by mini-css-extract-plugin
export default {"card":"styles_card__GKPkg","label":"styles_label__-926Q","text":"styles_text__UFcQs"};